<template>

  <ul class="pcb-select-container" :style="{gap:props.gap}">
    <pcb-item
      :min-width="minWidth"
      :is-error="status"
      :isColor="isColor"
      v-for="item in dicDataFirst"
      v-bind="item"
      :key="item.value"
      @click="handleSelect(item)"
      :checked="modelValue === item.value"
    >
      {{ item?.label }}
    </pcb-item>
    <Dropdown v-if="dicDataLast.length > 0" v-model:popup-visible="visible" :key="`dropdown-${DicDataFilter.length}-${props.row}`">
      <pcb-item
        :isColor="isColor"
        :bg="!isSelectedInDropdown"
        :min-width="moreMinWidth"
        :checked="
          !validataNull(
            dicDataLast.find((item) => item.value === modelValue)?.label
          )
        "
      >
      <span v-if="dicDataLast.find((item) => item.value === modelValue)">{{ dicDataLast.find((item) => item.value === modelValue)?.label }}</span>
      <span v-else>{{ moreText }}</span>
        <span
          :class="{
            active_color: dicDataLast.find((item) => item.value === modelValue),
          }"
          :style="{
            color: visible ? 'var(--main-color)' : 'var(--main-color)',
          }"
          style="margin-left: 3px"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="7"
            viewBox="0 0 8 7"
            fill="none"
          >
            <path
              d="M4.40544 5.9382C4.20587 6.21473 3.79413 6.21473 3.59456 5.9382L0.241885 1.2926C0.00323535 0.961921 0.239523 0.5 0.647327 0.5L7.35267 0.500001C7.76048 0.500001 7.99676 0.961922 7.75812 1.2926L4.40544 5.9382Z"
              fill="#0060FF"
            />
          </svg>
        </span>
      </pcb-item>
      <template #content>
        <pcb-item
        :isColor="isColor"
          :no-border="true"
          v-for="item in dicDataLast"
          v-bind="item"
          :min-width="moreMinWidth"
          :key="item.value"
          @click="handleSelect(item)"
          :checked="modelValue === item.value"
        >
          <span style="margin: 0 10px">{{ item?.label }}</span>
        </pcb-item>
      </template>
    </Dropdown>
    <div v-if="footer" v-html="footer"></div>
  </ul>
</template>
<script setup>
import PcbItem from "./pcb-item.vue";
import { Dropdown } from "@arco-design/web-vue";
import { validataNull } from "../utils";
import { computed, ref, inject, watch,nextTick,toRaw } from "vue";
import { formItemInjectionKey } from "@arco-design/web-vue/es/form/context";

const formItemCtx = inject(formItemInjectionKey, null);

const status = computed(() => {
  return formItemCtx?.error;
});
defineOptions({
  name: "pcb-select",
});
 const isSelectedInDropdown = computed(() => {
  return dicDataLast.value.find((item) => item.value === modelValue.value);
 })
const visible = ref(false);
const moreText = computed(() => {
  // 检查当前选中的值是否在下拉列表中
  const selectedInDropdown = dicDataLast.value.find((item) => item.value === modelValue.value);
  if(selectedInDropdown){
    return selectedInDropdown.label;
  }
  else if(dicDataLast.value.length > 0) {
    return props.more
      ? props.more
      : dicDataLast.value[0]?.label +
          "-" +
          dicDataLast.value[dicDataLast.value.length - 1]?.label;
  }
  return "";
});
const DicDataFilter = computed(() => {
  // 防御性检查：确保 dicData 存在且为数组
  if (!props.dicData || !Array.isArray(props.dicData)) {
    return [];
  }
  
  const fList = props.dicData.filter((item) => {
    // 更严格的过滤条件
    return item && typeof item === 'object' && item.show !== false;
  });
  
  // 如果需要自动更新 modelValue，可以使用以下逻辑：
  // if(fList.length > 0 && !fList.some(item => item.value === modelValue.value)){
  //   updateValue(fList[0].value);
  // }
  // if(fList.length === 0 && props.dicData.some(item => item.value === modelValue.value)){
  //   updateValue(Array.isArray(modelValue.value) ? [] : '');
  // }
  
  return fList;
});
const dicDataFirst = computed(() => {
  // 防御性检查：确保 DicDataFilter 存在且为数组
  if (!DicDataFilter.value || !Array.isArray(DicDataFilter.value)) {
    return [];
  }
  
  // 如果 row <= 0 或者总数据不足，显示全部
  if (props.row <= 0 || DicDataFilter.value.length <= props.row) {
    return DicDataFilter.value;
  }
  
  const remainingItems = DicDataFilter.value.slice(props.row);
  
  // 如果剩余项只有1个，将其合并到主显示区域
  if (remainingItems.length === 1) {
    return DicDataFilter.value.slice(0, props.row + 1);
  }
  
  // 如果有多个剩余项，只显示前 row 个
  return DicDataFilter.value.slice(0, props.row);
});
const dicDataLast = computed(() => {
  // 防御性检查：确保 DicDataFilter 存在且为数组
  if (!DicDataFilter.value || !Array.isArray(DicDataFilter.value)) {
    return [];
  }
  
  // 只有当 row > 0 且有足够的数据时才处理分割逻辑
  if (props.row <= 0 || DicDataFilter.value.length <= props.row) {
    return [];
  }
  
  const remainingItems = DicDataFilter.value.slice(props.row);
  
  // 如果剩余项为空，返回空数组
  if (!remainingItems.length) {
    return [];
  }
  
  // 如果只有1个剩余项，检查 dicDataFirst 的处理逻辑
  // 当 dicDataFirst 将最后一项合并时，这里应该返回空数组
  if (remainingItems.length === 1) {
    // 确保与 dicDataFirst 的逻辑保持一致
    return [];
  }
  
  // 返回多个剩余项
  return remainingItems;
});
const modelValue = defineModel();
const props = defineProps({
  dicData: {
    type: Array,
    default: () => [],
  },
  row: {
    type: Number,
    default: 0,
  },
  footer: {
    type: String,
    default: "",
  },
  minWidth: {
    type: Number,
  },
  moreMinWidth: {
    type: Number,
    default: 50,
  },
  more: {
    type: String,
    default: "",
  },
  deep:{
    default:true,
  },
  isColor:{
    type:Boolean,
    default:true,
  },
  gap:{
    type:Number,
    default:'6px',
  }
});
const emit = defineEmits(["change",'dicClicked']);

// 统一的值更新函数，确保 change 事件总是被触发
const updateValue = (newValue) => {
  const oldValue = modelValue.value;
  if (oldValue !== newValue) {
    modelValue.value = newValue;
    if (props.deep !== false) {
      nextTick(() => {
        emit("change", newValue);
      });
    }
  }
};
const handleSelect = (item) => {
  if (item.disabled) {
    return;
  }
  updateValue(item.value);
  visible.value = false; // 选择后关闭下拉框
  nextTick(()=>{
    emit("dicClicked", toRaw(item));
  })
};
</script>
<style scoped>
.active_color {
  color: var(--main-color);
}
:deep(.arco-scrollbar-track) {
  width: 0px !important;
}
:deep(.arco-scrollbar-track-direction-vertical) {
  display: none !important;
}
:deep(.arco-scrollbar-thumb-bar) {
  background-color: transparent !important;
}
:deep(.arco-dropdown){
  padding: 0px !important;
}

</style>
